// extracted by mini-css-extract-plugin
export default {"newQuestion":"YDhPepkv4IMlA0sN","questionSelector":"_lcd7Zv2V2IlYEOj"};